import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import { DevelopmentsFilter } from '../services/developments-api.service';

const DEVELOPMENTS_SCOPE = '[Developments]';
const API_SCOPE = `${ DEVELOPMENTS_SCOPE } API`;

export namespace DevelopmentsActions {

  export class Get extends StoreAction<DevelopmentsFilter> {
    static override readonly type = `${ API_SCOPE } Get`;

    constructor(public override payload?: DevelopmentsFilter) {
      super(payload);
    }
  }

  export class GetSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get Success`;
  }

  export class GetFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get Failed`;
  }

  export class GetById extends StoreAction<number> {
    static override readonly type = `${ API_SCOPE } Get By Id`;

    constructor(public override payload: number) {
      super(payload);
    }
  }

  export class GetByIdSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Get By Id Success`;
  }

  export class GetByIdFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Get By Id Failed`;
  }

  export class ToggleFavorite extends StoreAction<number> {
    static override readonly type = `${ API_SCOPE } Toggle Favorite`;

    constructor(public override payload: number) {
      super(payload);
    }
  }

  export class ToggleFavoriteSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Toggle Favorite Success`;
  }

  export class ToggleFavoriteFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Toggle Favorite Failed`;
  }

  export class Select extends StoreAction<string> {
    static override readonly type = `${ DEVELOPMENTS_SCOPE } Select`;

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ DEVELOPMENTS_SCOPE } Reset Loaded State`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ DEVELOPMENTS_SCOPE } Reset State`;
  }
}
